import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97757c94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card rounded text-center p-3 d-flex justify-content-between",
  style: {"border":"1px solid #b5b5c3","position":"relative"}
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "card-text",
  style: {"min-height":"30px"}
}
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center gap-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#B5B5C3"} }, "SLA:", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "arrow",
  style: {"position":"absolute","right":"-22px","top":"80px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.iconName)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require(`../../../assets/filter/${_ctx.iconName}.svg`),
            alt: ""
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        style: _normalizeStyle([{"height":"5px","width":"5px","border-radius":"50%"}, { 'background-color': _ctx.dotColor }])
      }, null, 4),
      _hoisted_6,
      (_ctx.sla)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.sla === 1 ? `${_ctx.sla} Dia` : `${_ctx.sla} Dias`), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, "0 Dias"))
    ]),
    (_ctx.arrow)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " >> "))
      : _createCommentVNode("", true)
  ]))
}